import {
  defaultSingleObjectState,
  defaultManyObjectState,
  defaultManyObjectPayload,
} from "utils/constants";
import * as types from "./types";
import { extractStatus, handleReduxAction } from "helpers/reduxHelpers";

const initalState = {
  allScripts: defaultSingleObjectState,
  singleScript: defaultSingleObjectState,
  userInfo: defaultSingleObjectState,
  search: defaultManyObjectState,
  searchResult: defaultManyObjectState,
  myScripts: defaultManyObjectState,
  createScript: defaultSingleObjectState,
  createScriptBulk: defaultSingleObjectState,
  adminScripts: defaultManyObjectState,
  verifyScript: defaultSingleObjectState,
  editScript: null,
  editComposer: null,
  editScriptStateAPI: defaultSingleObjectState,
};

const scriptsRequecer = (
  state = initalState,
  { type, payload = defaultManyObjectPayload }: any,
) => {
  const status = extractStatus(type);

  switch (type) {
    case types.GET_SCRIPTS.request:
    case types.GET_SCRIPTS.error:
      return handleReduxAction(state, payload, status, "allScripts");
    case types.GET_SCRIPTS.success:
      return scriptSuccess(payload, state);
    case types.GET_SCRIPT.request:
    case types.GET_SCRIPT.success:
    case types.GET_SCRIPT.error:
      return handleReduxAction(state, payload, status, "singleScript");
    case types.VERIFY_SCRIPT.request:
    case types.VERIFY_SCRIPT.success:
    case types.VERIFY_SCRIPT.error:
      return handleReduxAction(state, payload, status, "verifyScript");
    case types.GET_SCRIPTS_ADMIN.request:
    case types.GET_SCRIPTS_ADMIN.success:
    case types.GET_SCRIPTS_ADMIN.error:
      return handleReduxAction(state, payload, status, "adminScripts");
    case types.MY_SCRIPTS.request:
    case types.MY_SCRIPTS.success:
    case types.MY_SCRIPTS.error:
      return handleReduxAction(state, payload, status, "myScripts");
    case types.CREATE_SCRIPT.request:
    case types.CREATE_SCRIPT.error:
    case types.CREATE_SCRIPT.success:
      return handleReduxAction(state, payload, status, "createScript");
    case types.CREATE_SCRIPT_BULK.request:
    case types.CREATE_SCRIPT_BULK.error:
    case types.CREATE_SCRIPT_BULK.success:
      return handleReduxAction(state, payload, status, "createScriptBulk");
    case types.CURRENT_USER_INFO_SCRIPT.request:
    case types.CURRENT_USER_INFO_SCRIPT.success:
    case types.CURRENT_USER_INFO_SCRIPT.error:
      return handleReduxAction(state, payload, status, "userInfo");
    case types.SEARCH_SCRIPT.request:
    case types.SEARCH_SCRIPT.success:
    case types.SEARCH_SCRIPT.error:
      return handleReduxAction(state, payload, status, "search");
    case types.SEARCH_RESULT.request:
    case types.SEARCH_RESULT.success:
    case types.SEARCH_RESULT.error:
      return handleReduxAction(state, payload, status, "searchResult");

    case types.EDIT_SCRIPT.request:
    case types.EDIT_SCRIPT.error:
    case types.EDIT_SCRIPT.success:
      return handleReduxAction(state, payload, status, "editScriptStateAPI");
    case "EDIT_SCRIPT":
      return {
        ...state,
        editScript: payload,
      };
    case "EDIT_COMPOSER":
      return {
        ...state,
        editComposer: payload,
      };
    case types.UPDATE_MY_SCRIPTS.success:
      return {
        ...state,
        myScripts: {
          ...state.myScripts,
          data: {
            ...state.myScripts.data,
            // @ts-expect-error: This variable intentionally has an incompatible type
            scripts: [payload.data, ...state.myScripts.data.scripts],
          },
        },
      };
    case types.DELETE_SCRIPT.success:
      return {
        ...state,
        myScripts: {
          ...state.myScripts,
          data: {
            ...state.myScripts.data,
            scripts: [
              // @ts-expect-error: This variable intentionally has an incompatible type
              ...state.myScripts.data.scripts.filter((script) => script.id !== payload.id),
            ],
          },
        },
      };

    case types.FOLLOW_USER.success:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          data: {
            ...state.userInfo.data,
            isFollowing: true,
          },
        },
      };
    case types.UNFOLLOW_USER.success:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          data: {
            ...state.userInfo.data,
            isFollowing: false,
          },
        },
      };
    case types.ADD_FAVOURITE.success:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          data: {
            ...state.userInfo.data,
            hasFavorited: true,
          },
        },
        singleScript: {
          ...state.singleScript,
          data: {
            ...state.singleScript.data,
            favoriteCount: Number(state.singleScript.data.favoriteCount) + 1,
          },
        },
      };
    case types.REMOVE_FAVOURITE.success:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          data: {
            ...state.userInfo.data,
            hasFavorited: false,
          },
        },
        singleScript: {
          ...state.singleScript,
          data: {
            ...state.singleScript.data,
            favoriteCount: state.singleScript.data.favoriteCount - 1,
          },
        },
      };

    // update for rating
    // case types.RATE_SCRIPT.success:
    //   return {
    //     ...state,
    //     singleScript: {
    //       ...state.singleScript,
    //       data: {
    //         ...state.singleScript.data,
    //         ratingCount: state.singleScript.data.ratingCount + 1
    //       }
    //     },

    //   }

    default:
      return state;
  }
};

export default scriptsRequecer;
function scriptSuccess(
  payload: any,
  state: {
    allScripts: SingleObjectState<GenericRecord<any>>;
    singleScript: SingleObjectState<GenericRecord<any>>;
    editComposer: null;
    userInfo: SingleObjectState<GenericRecord<any>>;
    search: ManyObjectState<GenericRecord<any>>;
    searchResult: ManyObjectState<GenericRecord<any>>;
    myScripts: ManyObjectState<GenericRecord<any>>;
    createScript: SingleObjectState<GenericRecord<any>>;
    verifyScript: SingleObjectState<GenericRecord<any>>;
    createScriptBulk: SingleObjectState<GenericRecord<any>>;
    adminScripts: ManyObjectState<GenericRecord<any>>;
    editScript: null;
    editScriptStateAPI: SingleObjectState<GenericRecord<any>>;
  },
) {
  const { paginationMeta, data } = payload;
  return {
    ...state,
    allScripts: {
      ...state.allScripts,
      processing: false,
      success: true,
      processed: true,
      data: {
        ...state.allScripts.data,
        [`page${paginationMeta.currentPage}`]: data,
      },
      paginationMeta: payload.paginationMeta,
    },
  };
}
